import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import FollowupRepository from '@/shared/http/repositories/associate/followup'
const PATH_URL_API = process.env.APIBaseURLCore

const historyMnemonics = [
  'sys_atualizacao_cadastral', 'sys_telefone_adicionado', 'sys_endereco_adicionado',
  'sys_responsavel_adicionado', 'sys_nova_oportunidade', 'sys_oportunidade_perdida',
  'sys_oportunidade_reativada', 'sys_oportunidade_excluida', 'sys_oportunidade_ganha',
  'sys_oportunidade_finalizada', 'sys_card_movido', 'sys_produto_adicionado',
  'sys_produto_ganho', 'sys_produto_perdido', 'sys_produto_reativado', 'sys_produto_editado',
  'sys_produto_excluido', 'sys_produto_liquidado', 'sys_ajuizamento_encerrado', 'sys_ajuizamento_reaberto',
  'sys_ajuizamento_adicionado', 'sys_ajuizamento_editado'
]

const followupMnemonics = [
  'sys_agendamento', 'sys_email_enviado', 'sys_ligacao',
  'sys_nova_conta_capital', null
]

export default {
  name: 'CrmDetailsTimeline',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      history: [],
      followup: []
    }
  },
  created () {
    this.onSyncData()
  },
  methods: {
    onLoad () {},
    onSyncData () {
      if (this.card && this.card.id) {
        this.onLoadAllFollowup()
      }
    },
    onLoadAllFollowup () {
      FollowupRepository.GetAllByCardId(this.card.id)
        .then(response => {
          this.history = this.filterByMnemonic(response.data.content, historyMnemonics)
          this.followup = this.filterByMnemonic(response.data.content, followupMnemonics)
        })
        .catch(this.onException)
    },
    filterByMnemonic (content, mnemonics) {
      return content.filter(historico => {
        if (historico.eventoDTO) {
          return mnemonics.includes(historico.eventoDTO.mnemonic)
        } else {
          return false
        }
      })
    },

    sortHistory () {
      this.history.sort((a, b) => a.id - b.id)
    },
    onDownloadFile (obj, file) {
      if (obj && file) {
        FollowupRepository.FileShare(obj.id, file.uuid)
          .then((response) => {
            if (response.status === 200) {
              let data = response.data
              if (data && data.uuid) {
                window.open(`${PATH_URL_API}/arquivos/compartilhados/${data.uuid}/download`)
              }
            }
          })
          .catch(this.onException)
      }
    },
    onDownloadFileDespesa (obj, file) {
      if (obj && file) {
        FollowupRepository.FileShareDespesas(obj.id, file.uuid)
          .then((response) => {
            if (response.status === 200) {
              let data = response.data
              if (data && data.uuid) {
                window.open(`${PATH_URL_API}/arquivos/compartilhados/${data.uuid}/download`)
              }
            }
          })
          .catch(this.onException)
      }
    },
    somaValorDespesas (despesas) {
      if (despesas.length > 0) {
        return this.formatValue(despesas.reduce((total, x) => total + x.valor, 0))
      }
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/timeline/timeline.js